export class WebOrderMinimumDateTimeSetup {
    refNo: number;
    // deliveryDate:string;
    deliveryTime: string;
    maxDeliveryTime: string;
}